import { Avatar, Box, Typography } from "@mui/material";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";
import React from "react";
// import { useAuth } from "react-oidc-context";
import ProfileMenu from "./ProfileMenu";

export function AvatarField(props) {
  // const auth = useAuth();
  const { cInfo } = GetCInfo();
  const { dataObj } = GetData();
  return (
    <React.Fragment>
      <ProfileMenu />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: "8px",
        }}
      >
        <Avatar
          alt={dataObj?.clientName}
          // src={""}
          sx={{
            color: "inherit",
            height: "100px",
            width: "100px",
          }}
        >
          {dataObj?.clientName ? dataObj?.clientName.charAt(0) : ""}
        </Avatar>
      </Box>
      <Box sx={{ alignSelf: "center", textAlign: "center", width: "100%" }}>
        <Typography variant="h5">{dataObj?.clientName}</Typography>
        <Box
          sx={{
            alignItems: "baseline",
            display: "flex",
            flexDirection: "row",
            gap: "4px",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {(cInfo?.style?.logoMain?.url || cInfo?.style?.logoSecond?.url) && (
            <img
              alt="logo"
              src={cInfo?.style?.logoMain?.url || cInfo?.style?.logoSecond?.url}
              style={{
                height: "13px",
                width: "auto",
              }}
            />
          )}
          <Typography variant="body1">{cInfo?.name}</Typography>
        </Box>
      </Box>
    </React.Fragment>
  );
}
